import React, { useState, useEffect } from "react";
import {
  Typography,
  Container,
  Box,
  Button,
  Card,
  CardContent,
  Grid2,
  Grid,
} from "@mui/material";
import UserIconAP from "../../../images/UserIconAP.svg";
import ProjectsIcon from "../../../images/ProjectsIcon.svg";
import TokenConsumption from "../../../images/TokenConsumption.svg";
import DownloadIcon from "../../../images/DownloadIcon.svg";

// import NavigationRail from "./NavigationRail";
import {
  getAllCapabilities,
  getAllUsers,
  getFiltertedCapablity,
  getServiceRequest,
} from "../../../services/webServices.js";
// import {
//   ChartComponent,
//   Dropdowns,
//   handleDownloadReport,
//   ServicesChart,
//   TopServicesChart,
//   UserActivityChart,
// } from "../../main-pages/output-pages/adminpages/resuable-functions/resuableFunctions";
import SessionExpired from "../../popup-components/SessionExpiredPopup";
import handleDownloadReport from "./summary-page-components/downloadFunctionality.js";
import {
  ChartComponent,
  ServicesChart,
  TopServicesChart,
  UserActivityChart,
} from "./summary-page-components/dashboardGraphs.js";
import ProjectsLeaderBoard from "./summary-page-components/projectsLeaderBoard.js";
import Leaderboard from "./summary-page-components/usersLeaderBoard.js";
// import { color } from "echarts";

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [topusers, setTopusers] = useState([]);
  const [servicerequest, setServicerequest] = useState([]);
  const [status, setStatus] = useState([]);
  const [sessionTime, setSessionTime] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedCapability, setSelectedCapability] = useState("");
  const [totalTokensUsed, setTotalTokensUsed] = useState(0);
  const [capabilities, setCapabilities] = useState([]);

  useEffect(() => {
    const getCapabilitiesForDropDown = async () => {
      try {
        const response = await getAllCapabilities();
        setCapabilities(response.data);
      } catch (error) {
        console.error("Error fetching capabilities:", error);
      }
    };
    getCapabilitiesForDropDown();
  }, []);

  const getUsers = async () => {
    try {
      const response = await getAllUsers();
      const allUsers = response.data.data;
      const totalTokensUsed = response.data.totalTokens;
      setTotalTokensUsed(totalTokensUsed);
      setUsers(allUsers);
    } catch (error) {
      console.error("Failed to fetch users:", error);
      if (error.response.data.message === "Your session has expired.") {
        setSessionTime(true);
      }
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await getServiceRequest();

      // Ensure data array exists
      if (response.data.data && response.data.data.length > 0) {
        setServicerequest(response.data);
        const statuses = response.data.data.map(
          (project) => project.project_data?.Status || "Unknown"
        );
        setStatus(statuses);
      } else {
        console.warn("No projects found in response.");
      }
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };

  const capabilityFiltering = async () => {
    try {
      const response = await getFiltertedCapablity({
        capability_name: selectedCapability,
        from_date: fromDate,
        to_date: toDate,
      });
      const sortedCapability = [...response.data.data]
        .sort((a, b) => b.tokens_used - a.tokens_used)
        .slice(0, 20);

      setTopusers(sortedCapability);
    } catch (error) {
      console.error("Failed to get filtered capability:", error);
    }
  };

  useEffect(() => {
    // if (selectedCapability) {
    capabilityFiltering();
    // }
  }, [selectedCapability, fromDate, toDate]);

  useEffect(() => {
    fetchProjects();
    getUsers();
  }, []);

  const [newUsersCount, setNewUsersCount] = useState(0);

  useEffect(() => {
    const storedCount = sessionStorage.getItem("newUsersCount");
    if (storedCount) {
      setNewUsersCount(parseInt(storedCount));
    }

    // Listen for changes from other tabs or components
    const handleStorageChange = (event) => {
      if (event.key === "newUsersCount") {
        setNewUsersCount(parseInt(event.newValue) || 0);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <Box sx={{ display: "flex",
        bgcolor: "#F5F5F2",
        height: "calc(100vh - 150px)", // adjust as needed
        overflowY: "auto",
        maxHeight: "100vh", }}>
      {/* Fixed navigation rail */}
      {/* <NavigationRail /> */}

      <Container
        component="main"
        maxWidth={false}
        sx={{
          marginLeft: "10px",
          marginRight: "10px",
          // height: "calc(100vh - 150px)", // adjust as needed
          bgcolor: "#f5f5f5",
          flexDirection: "column",
          flexGrow: 1, // Allow the container to take up remaining space
          // height: "100vh", // Full viewport height
          overflowY: "auto", // Enable vertical scrolling
          padding: "10px",
        }}
      >
        <Box sx={{ my: 1 }}>
          <Box
            sx={{
              my: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0, // Prevent shrinking
            }}
          >
            <Typography variant="h6" component="h1" gutterBottom>
              Dashboard
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}></Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  color: "#0094FB",
                  border: "1px solid #0094FB",
                  textTransform: "none",
                }}
                endIcon={
                  <img
                    src={DownloadIcon}
                    alt="Download"
                    style={{ width: 16, height: 16, marginLeft: "5px" }}
                  />
                }
                onClick={handleDownloadReport}
              >
                <b>Download Report</b>
              </Button>
            </Box>
          </Box>

          <Grid
            container
            spacing={3}
            sx={{ marginBottom: "20px", marginTop: "-10px" }}
          >
            {/* Total Users Card */}

            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensure proper positioning of footer
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Reserve space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={UserIconAP}
                      alt="User Icon"
                      style={{
                        width: "50px",
                        height: "80px",
                        marginLeft: "-10px",
                      }}
                    />
                    <Box>
                      <Typography variant="p" color="textSecondary">
                        Total Users
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography variant="h6">{users.length}</Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "green",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          ⬈ {newUsersCount} New Users
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f6f6f6",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      Active:{" "}
                      <span style={{ color: "black" }}>
                        {
                          users.filter(
                            (user) => user.status?.toLowerCase() === "active"
                          ).length
                        }
                      </span>
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "20px" }}
                    >
                      Inactive:{" "}
                      <span style={{ color: "red" }}>
                        {
                          users.filter(
                            (user) => user.status?.toLowerCase() === "inactive"
                          ).length
                        }
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>

            {/* Total Projects Card */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensure footer sticks to the bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={ProjectsIcon}
                      alt="User Icon"
                      style={{
                        width: "30px",
                        height: "80px",
                        marginLeft: "-10px",
                      }}
                    />
                    <Box>
                      <Typography variant="p" color="textSecondary">
                        Total Projects
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography variant="h6">
                          {users.length > 0 ? users[0].total_projects : 0}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      Active:{" "}
                      <span style={{ color: "black" }}>
                        {
                          status.filter(
                            (user) => user.toLowerCase() === "active"
                          ).length
                        }
                      </span>
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "10px" }}
                    >
                      Inactive:{" "}
                      <span style={{ color: "red" }}>
                        {
                          status.filter(
                            (user) => user.toLowerCase() === "inactive"
                          ).length
                        }
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>

            {/* Token Consumption Card */}

            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensures footer stays at the bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Reserve space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={TokenConsumption}
                      alt="Token Icon"
                      style={{
                        width: "50px",
                        height: "80px",
                        marginLeft: "-20px",
                      }}
                    />
                    <Box>
                      <Typography variant="body2" color="textSecondary">
                        Token Consumption
                      </Typography>
                      <Typography variant="h6">{totalTokensUsed}</Typography>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    {/* <Typography variant="body1" sx={{ color: "grey" }}>
                      Total:
                     
                    </Typography> */}
                    {/* <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "10px" }}
                    >
                      Remaining:{" "}
                      <span style={{ color: "red" }}>
                       
                      </span>
                    </Typography> */}
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>

          {/* //DropDowns TO Filter Charts */}
          {/* <Dropdowns /> */}

          {/* Charts Section */}
          <Grid2 container spacing={3} sx={{ marginBottom: "20px" }}>
            {/* Grid2 for 1st graph */}
            <Grid2 item xs={12} sm={6} sx={{ height: "50%" }}>
              <TopServicesChart />
            </Grid2>

            {/* Grid2 for 2nd graph */}
            <Grid2 item xs={12} sm={6}>
              <UserActivityChart />
            </Grid2>

            {/* Grid2 for 3rd graph */}
            <Grid2 item xs={12} sm={6}>
              <ChartComponent />
            </Grid2>

            {/* Grid2 for 4th graph */}
            <Grid2 item xs={12} sm={6}>
              <ServicesChart />
            </Grid2>

            <Grid2 item xs={12} sm={4}>
              <Leaderboard
                selectedCapability={selectedCapability}
                setSelectedCapability={setSelectedCapability}
                topusers={topusers}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                capabilities={capabilities}
              />
            </Grid2>

            <Grid2 item xs={12} sm={4}>
              <ProjectsLeaderBoard />
            </Grid2>
          </Grid2>
        </Box>
      </Container>
      {sessionTime && <SessionExpired />}
    </Box>
  );
};

export default AdminDashboard;
